// extracted by mini-css-extract-plugin
export default {"filter":"filter_filter__kF2Zl","icon":"filter_icon__SH5WT"};